document.addEventListener('DOMContentLoaded', () => {
    const button = document.querySelector('.js-to-top');
    if (!button) return;

    const progress = button.querySelector('.scroll-top__value');
    const revealAt = 2000;
    let ticking = false;

    function updateButton() {
        const scrollTop = window.scrollY;
        const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
        const progressValue = scrollableHeight > 0 ? Math.min(scrollTop / scrollableHeight, 1) : 0;
        const isVisible = scrollTop >= revealAt;

        button.classList.toggle('is-visible', isVisible);
        button.setAttribute('aria-hidden', String(!isVisible));
        button.tabIndex = isVisible ? 0 : -1;

        if (progress) {
            progress.style.strokeDashoffset = String(100 - (progressValue * 100));
        }

        ticking = false;
    }

    function requestUpdate() {
        if (!ticking) {
            window.requestAnimationFrame(updateButton);
            ticking = true;
        }
    }

    button.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
    });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    updateButton();
});
